export const paddingY = '65px';
export const paddingX = '60px';
export const extraPaddingX = '117px';
